import React from 'react';

export const LoadingIndicatorContext = React.createContext(null);

export const AD_CREATIVE_PROCESSING_LOADING_MODAL = Object.freeze({
  title: 'Your creative is uploading and processing',
  message: 'Please wait for it to complete. Do not refresh or close this page while your image or video is being prepared.',
});

const LoadingIndicatorProvider = (props) => {
  const [shown, setShown] = React.useState(null);
  const [modalContent, setModalContent] = React.useState(null);

  const loadingIndicatorProviderValue = React.useMemo(() => ({
    isLoadingIndicatorModalShowing: shown,
    loadingIndicatorModalContent: modalContent,
    showLoadingIndicatorModal: (content = null) => {
      setModalContent(content);
      setShown(true);
    },
    hideLoadingIndicatorModal: () => {
      setShown(false);
      setModalContent(null);
    },
  }), [modalContent, shown]);

  return <LoadingIndicatorContext.Provider value={loadingIndicatorProviderValue} {...props} />;
};

export const useLoadingIndicatorContext = () => React.useContext(LoadingIndicatorContext);

export default LoadingIndicatorProvider;
